import React from 'react'
import { SeeYourOrderButton } from './SeeYourOrderButton'
import { useParams } from 'react-router-dom'
import { Alert, Icon } from '@ztechapps/webui.util'

export default function MessageSent() {
  const { _id } = useParams()
  return (
    <div className="container">
      <div className="my-5 text-center">
        <Alert type="success">
          <div style={{ fontSize: '100px' }}>
            <Icon name="envelope-open-text" />
          </div>

          <h1>
            Your message has been successfully sent.
            <br />
          </h1>
          <p>Thank you for contacting us. We will contact you as soon as we review your message. </p>
          <SeeYourOrderButton _id={_id} />
        </Alert>
      </div>
    </div>
  )
}
